import { Button } from '@components/button';
import { Typography } from '@components/typography';
import { useDeleteWorkspaceMutation } from '@generated/graphql';
import { Stack } from '@mui/material';
import { clearWorkspaceFromCookie } from '@navigation/workspaceCookieUtils';
import { useNotifications } from '@notifications/Notifications';
import { navigate } from 'gatsby';

interface WorkspacesMoreDropdownDeleteModalProps {
  onClose: () => void;
  workspaceId: string;
  isLandingPageWorkspace: boolean;
}

export const WorkspacesMoreDropdownDeleteModal = ({
  onClose,
  workspaceId,
  isLandingPageWorkspace,
}: WorkspacesMoreDropdownDeleteModalProps) => {
  const { createAsyncNotification } = useNotifications();
  const [deleteWorkspaceMutation] = useDeleteWorkspaceMutation();
  const handleDelete = createAsyncNotification('Deleted workspace successfully', async () => {
    onClose();
    await deleteWorkspaceMutation({
      variables: { workspaceId },
      refetchQueries: ['GetWorkspaces', 'GetOrganizationSettings'],
    });
    // Clear the deleted workspace from the lastWorkspaceByOrg cookie
    // to prevent the app from trying to load it on refresh
    clearWorkspaceFromCookie(workspaceId);
    if (!isLandingPageWorkspace) {
      navigate('/');
    }
  });

  return (
    <Stack pt={4} gap={10} justifyContent="center">
      <Typography variant="body2" textAlign="center">
        Are you sure you want to delete this workspace?
      </Typography>
      <Stack gap={4}>
        <Button fullWidth onClick={handleDelete}>
          Delete
        </Button>
        <Button fullWidth variant="secondary" onClick={onClose}>
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
};
